import { PropsOf } from '../../../types';
import connect from './connect';
import MediaImport from './MediaImport';

export default connect(MediaImport);
export type MediaImportProps = PropsOf<ReturnType<typeof connect>>;
export { MediaType, TabName } from './MediaImport';
